import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/product/imports?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`/product/imports/${id}`, { params });
}

export async function create(body) {
  return request(`/product/imports`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/product/imports/${id}`, {
    method: 'POST',
    body,
  });
}